import { Box } from '@material-ui/core';

import { CloneWorkspaceSubTitle } from 'src/legacy/components/Onboarding';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BrandAvatar } from 'src/legacy/components/UI/Avatars/BrandAvatar';
import { useOnboardingQueryParams } from 'src/routes/onboarding/setup/hooks/useOnboardingQueryParams';
import { useGetCloneableStatusQuery } from 'src/services/api';

export const LegacyOnboardingPageHeader = ({
  title,
  subtitle,
}: {
  title?: string;
  subtitle?: string;
}) => {
  const { workspaceTemplateId, workspaceTemplateName } =
    useOnboardingQueryParams();

  const { data: cloneableStatusData } = useGetCloneableStatusQuery(
    workspaceTemplateId ?? '',
    {
      skip: workspaceTemplateId === undefined,
    },
  );

  const showCloningText = Boolean(
    cloneableStatusData?.isCloneable && workspaceTemplateId,
  );

  return (
    <>
      <BrandAvatar />
      <Box mt={1.5} mb={5} textAlign="center" px={{ xs: 2, sm: 0 }}>
        {title && <BaseTypography fontType="18Medium">{title}</BaseTypography>}
        {subtitle && (
          <Box mt={0.25}>
            <BaseTypography className="text-gray-small">
              {subtitle}
            </BaseTypography>
            {showCloningText && (
              <CloneWorkspaceSubTitle templateName={workspaceTemplateName} />
            )}
          </Box>
        )}
      </Box>
    </>
  );
};
